import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { observer, inject } from 'mobx-react'
/* eslint-enable */

import Container from '../../partials/Container'

import styleA from './style'
import styleB from '../../style'

import access from '../../../../utils/access'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

const PAYMENT_TYPE = [
  { name: 'paypal', label: 'PayPal' },
  { name: 'crypto', label: 'Crypto' },
  { name: 'wire', label: 'Bankwire' },
  { name: 'btc', label: 'Bitcoin' },
  // { name: 'btg', label: 'Bitcoin Gold' },
  // { name: 'bch', label: 'Bitcoin Coin' },
  { name: 'eth', label: 'Ethereum' },
  { name: 'ltc', label: 'Litecoin' }
  // { name: 'etc', label: 'Ethereum Classic' },
  // { name: 'doge', label: 'DOGE' }
]

@inject('Application', 'Community', 'Payment', 'Auth', 'User', 'Config')
@observer
export class CommunityApplication extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        active: false
      }
    }
  }

  componentWillMount () {
    const comId = this.props.match.params.comId
    const _searchApplications = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending) {
          return _searchApplications()
        }

        Promise.all([
          ...(!this.props.Community.all.slice().find(c => c.id === comId)
            ? [this.props.Community.getCommunity(comId)]
            : []),
          this.props.Application.getApplication(comId),
          this.props.Payment.getMethod(comId)
        ]).catch(e => {
          if (+e.response.status !== 404) {
            this.props.history.push(`/dashboard/community`)
          }
        })
      }, 500)
    }

    _searchApplications()
  }

  onDecisionSubmit (e) {
    e.preventDefault()
    this.props.Application.postApplicationDecision({
      comId: this.props.match.params.comId,
      approved: this.state.editor.approve,
      comment: this.state.editor.comment
    }).then(() => {
      this.setState({
        ...this.state,
        editor: {
          ...this.state.editor,
          active: false
        }
      })
    })
  }

  onDecisionClick (approve, e) {
    this.setState({
      ...this.state,
      editor: {
        active: true,
        approve
      }
    })
  }

  onReasonInputChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        comment: e.target.value
      }
    })
  }

  renderAdminActions () {
    const comId = this.props.match.params.comId
    const application = this.props.Application.all
      .slice()
      .find(a => a.comId === comId) || { pending: false }

    if (
      !application.pending ||
      !access.adminCom(this.props.User.me.permissions || {})
    ) {
      return null
    }

    return (
      <Col
        style={{
          overflow: `hidden`,
          position: `relative`,
          transition: `0.2s`
        }}
      >
        <ApplicationForm
          theme={THEME_LIST[this.props.Config.theme]}
          style={{
            transition: `0.2s`,
            width: `100%`,
            position: `absolute`,
            ...(this.state.editor.active
              ? {
                top: 0,
                left: `15px`
              }
              : {
                top: `-100px`,
                left: `15px`
              })
          }}
          editor={this.state.editor}
          onSubmit={this.onDecisionSubmit.bind(this)}
          onInputChange={this.onReasonInputChange.bind(this)}
        />
        <NavigationArea
          style={{
            transition: `0.2s`,
            width: `100%`,
            position: `absolute`,

            ...(!this.state.editor.active
              ? {
                top: 0,
                left: `15px`
              }
              : {
                top: `100px`,
                left: `15px`
              })
          }}
          onApproveClick={this.onDecisionClick.bind(this, true)}
          onRejectClick={this.onDecisionClick.bind(this, false)}
        />
      </Col>
    )
  }

  render () {
    const comId = this.props.match.params.comId
    const application = this.props.Application.all
      .slice()
      .find(a => a.comId === comId) || { pending: true }
    const community =
      this.props.Community.all.slice().find(a => a.id === comId) || {}

    const paymentMethod = this.props.Payment.methods[comId]

    return (
      <Container {...this.props}>
        <Row>
          <Col>
            <Row>
              <Col>
                <h2 className={css(styleB.headers.h2)}>
                  Community Application
                </h2>
              </Col>
              {this.renderAdminActions()}
            </Row>
            <Row>
              <Col
                xs='12'
                className={css(
                  styleA.approval.wrapper,
                  styleA[THEME_LIST[this.props.Config.theme].name]
                    ? styleA[THEME_LIST[this.props.Config.theme].name].approval
                        .wrapper
                    : null
                )}
              >
                <Row>
                  <Col>
                    <h4 className={css(styleA.headers.h4)}>Decision</h4>
                  </Col>
                </Row>
                <Row
                  className={css(
                    styleA.approval.topBox,
                    styleA[THEME_LIST[this.props.Config.theme].name]
                      ? styleA[THEME_LIST[this.props.Config.theme].name]
                          .approval.topBox
                      : null
                  )}
                >
                  <Col>
                    <Row>
                      <Col>
                        <span className={css(styleA.approval.value)}>
                          <i
                            className={`fa ${
                              application.pending
                                ? 'fa-clock'
                                : application.approved ? 'fa-check' : 'fa-times'
                            }`}
                          />
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <span className={css(styleA.approval.label)}>
                          decision
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <Row>
                      <Col>
                        <span className={css(styleA.approval.value)}>
                          <i
                            className={`fa ${
                              application.pending ? 'fa-clock' : 'fa-check'
                            }`}
                          />
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <span className={css(styleA.approval.label)}>
                          status
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row
                  className={css(
                    styleA.approval.commentBox,
                    styleA[THEME_LIST[this.props.Config.theme].name]
                      ? styleA[THEME_LIST[this.props.Config.theme].name]
                          .approval.commentBox
                      : null
                  )}
                >
                  <Col>
                    <Row>
                      <Col>
                        <span className={css(styleA.approval.commentLabel)}>
                          comment:
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <p className={css(styleA.approval.p)}>
                          {application.comment || 'no comment'}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col xs='12'>
                <Row>
                  <Col>
                    <h4 className={css(styleA.headers.h4)}>Details</h4>
                  </Col>
                </Row>
                <Row
                  className={css(
                    styleA.table.table,
                    styleA[THEME_LIST[this.props.Config.theme].name]
                      ? styleA[THEME_LIST[this.props.Config.theme].name].table
                          .table
                      : null
                  )}
                >
                  <Col
                    xs='6'
                    className={css(
                      styleA.table.col,
                      styleA[THEME_LIST[this.props.Config.theme].name]
                        ? styleA[THEME_LIST[this.props.Config.theme].name].table
                            .col
                        : null
                    )}
                  >
                    <Row
                      className={`flex-nowrap ${css(
                        styleA.table.row,
                        styleA[THEME_LIST[this.props.Config.theme].name]
                          ? styleA[THEME_LIST[this.props.Config.theme].name]
                              .table.row
                          : null
                      )}`}
                    >
                      <Col xs='3'>
                        <span>name</span>
                      </Col>
                      {/* <Col xs='auto' /> */}
                      <Col>
                        <input
                          className={css(styleA.table.input)}
                          value={community.name || ''}
                          onChange={() => {}}
                        />
                      </Col>
                    </Row>
                    <Row
                      className={`flex-nowrap ${css(
                        styleA.table.row,
                        styleA[THEME_LIST[this.props.Config.theme].name]
                          ? styleA[THEME_LIST[this.props.Config.theme].name]
                              .table.row
                          : null
                      )}`}
                    >
                      <Col xs='3'>
                        <span>motd url</span>
                      </Col>
                      {/* <Col xs='auto' /> */}
                      <Col>
                        <input
                          className={css(styleA.table.input)}
                          value={community.seo || ''}
                          onChange={() => {}}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    xs='6'
                    className={css(
                      styleA.table.col,
                      styleA[THEME_LIST[this.props.Config.theme].name]
                        ? styleA[THEME_LIST[this.props.Config.theme].name].table
                            .col
                        : null
                    )}
                  >
                    <Row
                      className={`flex-nowrap ${css(
                        styleA.table.row,
                        styleA[THEME_LIST[this.props.Config.theme].name]
                          ? styleA[THEME_LIST[this.props.Config.theme].name]
                              .table.row
                          : null
                      )}`}
                    >
                      <Col xs='3'>
                        <span>url</span>
                      </Col>
                      {/* <Col xs='auto' /> */}
                      <Col>
                        <input
                          className={css(styleA.table.input)}
                          value={community.url || ''}
                          onChange={() => {}}
                        />
                      </Col>
                    </Row>
                    <Row
                      className={`flex-nowrap ${css(
                        styleA.table.row,
                        styleA[THEME_LIST[this.props.Config.theme].name]
                          ? styleA[THEME_LIST[this.props.Config.theme].name]
                              .table.row
                          : null
                      )}`}
                    >
                      <Col xs='3'>
                        <span>payment</span>
                      </Col>
                      {/* <Col xs='auto' /> */}
                      <Col>
                        {!paymentMethod ? null : (
                          <input
                            className={css(styleA.table.input)}
                            value={
                              PAYMENT_TYPE.find(
                                p => p.name === paymentMethod.type
                              ).label
                            }
                            onChange={() => {}}
                          />
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    )
  }
}

export const ApplicationForm = props => {
  return (
    <form
      onSubmit={props.onSubmit}
      style={props.style || {}}
      className={`row ${css(styleA.form.container)}`}
    >
      <Col
        className={css(
          styleA.form.inputWrapper,
          styleA[props.theme.name]
            ? styleA[props.theme.name].form.inputWrapper
            : null
        )}
      >
        <input
          type={`text`}
          value={props.editor.comment}
          onChange={props.onInputChange}
          placeholder={`type...`}
          className={css(styleA.form.input)}
        />
      </Col>
      <Col xs='4' className={css(styleA.form.inputWrapper)}>
        <button
          className={css(
            styleB.buttons.button,
            styleB.buttons.red,
            styleA.form.button
          )}
        >
          {props.editor.approve ? 'Approve' : 'Reject'}
        </button>
      </Col>
    </form>
  )
}

export const NavigationArea = props => {
  return (
    <Row style={props.style || {}}>
      <Col>
        <span
          onClick={props.onApproveClick}
          className={css(styleB.buttons.button, styleB.buttons.red)}
        >
          Approve
        </span>
      </Col>
      <Col>
        <span
          onClick={props.onRejectClick}
          className={css(styleB.buttons.button, styleB.buttons.red)}
        >
          Reject
        </span>
      </Col>
    </Row>
  )
}

export default CommunityApplication



// WEBPACK FOOTER //
// ./src/components/Community/Application/Main/index.js